import React from "react";
import { Film, FileText, File } from "lucide-react";
import wordimage from "../../../assets/icons/word_v2.svg";
import excelimage from "../../../assets/icons/excel_v2.svg";
import pdfimage from "../../../assets/icons/pdf_v2.svg";
import zipimage from "../../../assets/icons/zip_v2.svg";
import { ImageIcon } from "lucide-react";

export function getFileIcon(fileType) {
  switch (fileType) {
    case "image":
      return <ImageIcon size={16} />;
    case "word":
      return <img src={wordimage} alt="Word Document" />;
    case "excel":
      return <img src={excelimage} alt="Excel Document" />;
    case "pdf":
      return <img src={pdfimage} alt="PDF Document" />;
    case "archive":
      return <img src={zipimage} alt="Archive" />;
    case "video":
      return <Film size={16} />;
    case "document":
      return <FileText size={16} />;
    default:
      return <File size={16} />;
  }
}

export function getFileType(fileName) {
  const extension = fileName.split(".").pop()?.toLowerCase() || "";

  if (["doc", "docx"].includes(extension)) return "word";
  if (["xls", "xlsx"].includes(extension)) return "excel";
  if (["zip", "7z", "rar"].includes(extension)) return "archive";
  if (["pdf"].includes(extension)) return "pdf";
  if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) return "image";
  if (["mp4", "mov", "avi", "webm"].includes(extension)) return "video";
  if (["txt", "rtf"].includes(extension)) return "document";

  return "other";
}

export function getMimeType(fileName) {
  const extension = fileName.split(".").pop()?.toLowerCase() || "";

  if (extension === "jpg" || extension === "jpeg") return "image/jpeg";
  if (extension === "png") return "image/png";
  if (extension === "gif") return "image/gif";
  if (extension === "webp") return "image/webp";
  if (extension === "pdf") return "application/pdf";
  if (extension === "doc" || extension === "docx") return "application/msword";
  if (extension === "txt") return "text/plain";
  if (extension === "rtf") return "application/rtf";
  if (extension === "zip") return "application/zip";
  if (extension === "rar") return "application/x-rar-compressed";
  if (extension === "7z") return "application/x-7z-compressed";
  if (extension === "mp4") return "video/mp4";
  if (extension === "mov") return "video/quicktime";
  if (extension === "avi") return "video/x-msvideo";
  if (extension === "webm") return "video/webm";

  return "application/octet-stream";
}

export function getFileColor(fileType) {
  switch (fileType) {
    case "pdf":
      return "bg-red-500";
    case "excel":
      return "bg-green-500";
    case "word":
      return "bg-blue-500";
    case "archive":
      return "bg-yellow-500";
    case "image":
      return "bg-gray-200";
    case "video":
      return "bg-purple-500";
    case "document":
      return "bg-indigo-500";
    default:
      return "bg-gray-300";
  }
}
